export default "__VITE_ASSET__BKigTDeN__"